import type { WorkflowStep } from './WorkflowStepProgress'
import type { VatechCtCatalogResolved } from './domain/vatechCtCatalog'
import { ctArchiveLabel } from './domain/ctArchiveLabel'

export type DiagnocatLinkState = {
  linked: boolean
  status: string
  legacyPatientId: number | null
}

export function buildCardWizardPreambleSteps(input: {
  tenantId?: string | null
  catalog: VatechCtCatalogResolved | null
  catalogLoading: boolean
  catalogError: string | null
  linkState: DiagnocatLinkState
  hasLinkCandidates: boolean
}): WorkflowStep[] {
  let catalogStatus: WorkflowStep['status'] = 'pending'
  if (input.catalogLoading) catalogStatus = 'active'
  else if (input.catalogError) catalogStatus = 'failed'
  else if (input.catalog) catalogStatus = 'done'

  let linkStatus: WorkflowStep['status'] = 'pending'
  if (input.linkState.linked) linkStatus = 'done'
  else if (input.hasLinkCandidates) linkStatus = 'active'
  else if (input.catalog && input.catalog.total === 0) linkStatus = 'skipped'

  const submitStatus: WorkflowStep['status'] =
    input.linkState.linked && (input.catalog?.total ?? 0) > 0 ? 'pending' : 'pending'

  return [
    {
      id: 'vatech_catalog',
      label: `Справочник КТ на ${ctArchiveLabel(input.tenantId)}`,
      detail: input.catalog?.total
        ? `${input.catalog.total} исследований`
        : input.catalogLoading
          ? 'Загружаем…'
          : 'КТ не найдено',
      status: catalogStatus,
    },
    {
      id: 'diagnocat_link',
      label: 'Связка с Diagnocat',
      detail: input.linkState.linked ? 'Подтверждена' : 'Подтвердите кандидата',
      status: linkStatus,
    },
    {
      id: 'submit_ct',
      label: 'Отправка КТ на анализ',
      detail: !input.linkState.linked ? 'Сначала подтвердите связку' : undefined,
      status: submitStatus,
    },
  ]
}
